import React from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';
import {socialLinks} from '../../../constants/links';
import {Label} from '../../../components/Labels';
import {FeatureScreen} from '../../../assets';

export const Hero = () => {
  return (
    <div className={styles.hero}>
      <div className={styles.container}>
        <div className={styles.top}>
          <div>
            <Label
              text="Vote for Themis on Top.gg! 🎉"
              href={socialLinks.twitter}
              target="_blank"
            />
          </div>
          <h1 className={styles.title}>
            Elevate your <span className={styles.decor}>server security</span>
          </h1>
          <p className={styles.subTitle}>
            Discord security has never been that easy and intitive. Unleash powerful tools to
            protect your community.
          </p>
        </div>
      </div>
      <div className={styles.containerImage}>
        <div className={styles.image}>
          <FeatureScreen />
        </div>
      </div>
      <div className={styles.ellispsWrapper}>
        <div className={clsx(styles.ellips)}></div>
        <div className={clsx(styles.ellips, styles.second)}></div>
        <div className={clsx(styles.ellips, styles.third)}></div>
      </div>
    </div>
  );
};
